// extracted by mini-css-extract-plugin
module.exports = {"file":"File_file__1h5hz","fileBtn":"File_fileBtn__3tQqI","closeBtn":"File_closeBtn__13fUq","fileSelected":"File_fileSelected__311P8","disabled":"File_disabled__3gz2Z"};